import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { Chart } from 'chart.js';

@Component({
    selector: 'app-license-tracker',
    templateUrl: './license-tracker-dialog.component.html',
    styleUrls: ['./license-tracker-dialog.component.scss'],
    standalone: false
})
export class LicenseTrackerComponent implements OnInit {
  @Input() totalCpLicenses!: number;
  @Input() totalCpCmLicenses!: number;
  @Input() companyName!: string;

  chart: Chart | null = null;
  /* istanbul ignore next */
  ngOnChanges(changes: SimpleChanges) {
    if (changes['totalCpLicenses'] || changes['totalCpCmLicenses']) {
      this.updateChart();
    }
  }
  /* istanbul ignore next */
  ngOnInit() {
    this.createChart();
  }
  /* istanbul ignore next */
  createChart() {
    const canvas = document.getElementById(
      'licenseTrackerChart'
    ) as HTMLCanvasElement;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    this.chart = new Chart(ctx, {
      type: 'pie',
      data: {
        labels: ['Total CP', 'Total CMCP'],
        datasets: [
          {
            label: 'Total Billable Credentials',
            data: [this.totalCpLicenses, this.totalCpCmLicenses],
            backgroundColor: ['rgb(162, 84, 210,1)', 'rgba(229, 214, 233, 1)'],
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
      },
    });
  }
  /* istanbul ignore next */
  updateChart() {
    if (this.chart) {
      this.chart.data.datasets![0].data = [
        this.totalCpLicenses,
        this.totalCpCmLicenses,
      ];
      this.chart.update();
    }
  }
}
